import type { ButtonHTMLAttributes } from 'react'
import { cn } from '@/shared/lib'
import { Icon, type IconName } from '@/shared/ui/icon'

export type IconButtonTone = 'neutral' | 'danger'

interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'aria-pressed'> {
  icon: IconName
  // Обязательная подпись: контрол без текста иначе недоступен скринридеру.
  label: string
  active?: boolean
  tone?: IconButtonTone
}

const base =
  'inline-flex items-center justify-center rounded-pill w-11 h-11 sm:w-12 sm:h-12 border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-accent disabled:opacity-40 disabled:pointer-events-none'

export function IconButton({
  icon,
  label,
  active = false,
  tone = 'neutral',
  type,
  className,
  ...rest
}: IconButtonProps) {
  // mute/выкл mic-cam (active+danger) — акцентная заливка; active+neutral — raised.
  // Неактивное состояние тоже с заливкой (bg-surface), иначе включённый контрол
  // сливается с фоном тулбара (bg-elevated) и «вкл/выкл» неотличимы.
  const danger = tone === 'danger'
  const stateClass = active
    ? danger
      ? 'bg-accent border-transparent text-text-inverse hover:bg-accent-hover'
      : 'bg-bg-raised border-border-strong text-text-primary'
    : 'bg-bg-surface border-border-default text-text-secondary hover:bg-bg-raised hover:text-text-primary hover:border-border-strong'

  return (
    <button
      type={type ?? 'button'}
      aria-label={label}
      aria-pressed={active}
      title={label}
      className={cn(base, stateClass, className)}
      {...rest}
    >
      <Icon name={icon} size={22} />
    </button>
  )
}
